import React from 'react'
import {KTSVG} from '../KTSVG'

interface Props {
 label?: string
 onClick?: () => void
 className?: string
 icon: string
}

const MenuButton = ({
 label,
 onClick,
 icon,
 className = '',
}: Props) => {
 return (
  <button
   type='button'
   onClick={onClick}
   className={`
        inline-flex items-center gap-2
        px-3 py-1.5
        rounded-full
        border border-[#4E83E4]
        text-[#4E83E4]
        text-sm font-medium
        hover:bg-[#EDF3FF]
        transition-colors duration-150
        ${className}
      `}
  >
   <KTSVG path={icon} svgClassName='w-6 h-6' />
   <span className='leading-none'>{label}</span>
  </button>
 )
}

export {MenuButton}
